import { t } from "@lingui/macro";
import React from "react";
import { CardTitle } from "../../common";
import { BillingEntity } from "./BillingEntity";
import { Brands } from "./Brands";
import { ContactPerson } from "./ContactPerson";

export const BrandDetails = () => (
  <React.Fragment>
    <CardTitle>{t`Brand Details`}</CardTitle>
    <Brands />
    <BillingEntity />
    <ContactPerson />
  </React.Fragment>
);
